import * as React from "react";
import type { SVGProps } from "react";
const SvgLogOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 22a1 1 0 1 0 0-2zm-6-3H2zM5 3V2zm4 1a1 1 0 0 0 0-2zm6.293 12.293a1 1 0 0 0 1.414 1.414zM21 12l.707.707a1 1 0 0 0 0-1.414zm-4.293-5.707a1 1 0 1 0-1.414 1.414zM9 11a1 1 0 1 0 0 2zm0 9H5v2h4zm-4 0a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 5 22zm-.707-.293A1 1 0 0 1 4 19H2a3 3 0 0 0 .879 2.121zM4 19V5H2v14zM4 5a1 1 0 0 1 .293-.707L2.879 2.879A3 3 0 0 0 2 5zm.293-.707A1 1 0 0 1 5 4V2a3 3 0 0 0-2.121.879zM5 4h4V2H5zm11.707 13.707 5-5-1.414-1.414-5 5zm5-6.414-5-5-1.414 1.414 5 5zM21 11H9v2h12z"
    />
  </svg>
);
export default SvgLogOut;
